package com.gavino.nutritrack

import kotlinx.coroutines.await

actual suspend fun platformHttpPut(url: String, jsonBody: String): Boolean {
    return try {
        // Kotlin/JS wrappa gli oggetti JS in modi inaspettati per il fetch API a volte.
        // E' più sicuro usare la funzione js() per eseguire il fetch direttamente in JS puro.
        val promise = js("window.fetch(url, { method: 'PUT', body: jsonBody, headers: { 'Content-Type': 'application/json' } })") as kotlin.js.Promise<dynamic>
        val response = promise.await()
        response.ok as Boolean
    } catch (e: Exception) {
        false
    }
}

actual suspend fun platformHttpGet(url: String): String? {
    return try {
        val promise = js("window.fetch(url, { method: 'GET' })") as kotlin.js.Promise<dynamic>
        val response = promise.await()
        if (response.ok as Boolean) {
            val textPromise = response.text() as kotlin.js.Promise<dynamic>
            textPromise.await() as String
        } else {
            null
        }
    } catch (e: Exception) {
        null
    }
}

actual fun platformShareText(title: String, text: String) {
    try {
        // Usa il menu di condivisione del browser (se presente) e copia il testo negli appunti
        js(
            """
            if (navigator.share) {
                navigator.share({ title: title, text: text }).catch(function(e) {});
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text);
            }
            """
        )
    } catch (e: Exception) {
        // La finestra di dialogo in Compose gestisce già anche i link diretti a WhatsApp e Mail
    }
}